<template>
  <div>
    <!-- HERO -->
    <PageHero
      :title="t('statistics.title')"
      :breadcrumbsTop="[
        { label: t('hero.breadcrumbs.home'), link: '/' },
        { label: t('hero.breadcrumbs.statistics') }
      ]"
    />

    <!-- CONTENT -->
    <div class="container py-10">
      <!-- Tabs -->
      <ul class="nav nav-tabs mb-4">
        <li class="nav-item">
          <button
            class="nav-link"
            :class="{ active: activeTab === 'sales' }"
            @click="activeTab = 'sales'"
          >
            {{ t('statistics.tabs.sales') }}
          </button>
        </li>

        <li class="nav-item">
          <button
            class="nav-link"
            :class="{ active: activeTab === 'permits' }"
            @click="activeTab = 'permits'"
          >
            {{ t('statistics.tabs.permits') }}
          </button>
        </li>
      </ul>

      <!-- Tab content -->
      <div class="tab-content">
        <div v-if="activeTab === 'sales'">
          <SalesChart />
        </div>

        <div v-else-if="activeTab === 'permits'">
          <PermitsChart />
        </div>
      </div>

      <!-- Data source -->
      <TuikDisclaimer class="mt-5" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import PageHero from '../components/PageHero.vue'
import SalesChart from '../pages/statistic_page/SalesStatisticChart.vue'
import PermitsChart from '../pages/statistic_page/ConstructionPermitsChart.vue'
import TuikDisclaimer from '../pages/statistic_page/TuikDisclaimer.vue'

const { t } = useI18n()
const activeTab = ref('sales')
</script>
